/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/pagination/custom-elements';

import { defineCustomElement as defineOsdsPagination } from '@ovhcloud/ods-stencil/components/pagination/custom-elements/osds-pagination.js';


export const OsdsPagination = /*@__PURE__*/ defineContainer<JSX.OsdsPagination>('osds-pagination', defineOsdsPagination, [
  'current',
  'totalItems',
  'totalPages',
  'disabled',
  'labelTooltipPrevious',
  'labelTooltipNext',
  'odsPaginationChanged'
]);

